/**
 * merlin_api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DeviceVM { 
    id?: number;
    deviceUuid?: string | null;
    deviceName?: string | null;
    generatedName?: string | null;
    isJoinedToSchool?: boolean;
    isDelivered?: boolean;
    status?: string | null;
    isRemovedInventory?: boolean;
    deviceType?: string | null;
    dlpDeviceType?: string | null;
    manufacturer?: string | null;
    model?: string | null;
    manufacturerSerialnumber?: string | null;
    androidId?: string | null;
    ekitabuAppId?: string | null;
    imei?: string | null;
    mac?: string | null;
    os?: string | null;
    osType?: string | null;
    osBuild?: string | null;
    username?: string | null;
    processor?: string | null;
    ram?: string | null;
    isScanned?: boolean;
    schoolId?: number;
    schoolName?: string | null;
    schoolLatitude?: number;
    schoolLongitude?: number;
    assetId?: string | null;
}

